import React,{Component} from 'react';
import "./style.less"
import {NavBar,Toast} from "antd-mobile";
import moment from 'moment';
import {connect} from "react-redux";
import {getOrderInfo} from "../../../service/homeService";
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class ReplaceOrderInfo extends Component{
    constructor(props) {
        super(props);
        console.log(props)
        this.state={
            passengerName:'',
            phone:'',
            seatNum:'',
            shiftNum:'',
            startTime:'',
            startAddress:'',
            endAddress:'',
            startPosition:'',
            endPosition:'',
            orderNum:'',
            orderTime:'',
            seatPrice:'',
            pickUpPrice:'',
            deliveryPrice:'',
            totalPrice:'',
            payChannel:'',//支付方式
            countDown: '',
            createTime: '',
            orderId:'',
        }
    }
  
    componentDidMount() {
        this.getOrderDetail();
    }
    //支付倒计时 支付倒计时为下单时间内9分钟内支付，超过9分钟订单变成已取消
    setDownTime(time) {
        if (time <= 0) {
            this.setState({
                countDown: 0,
               
            });
            Toast.info('支付过期，请重新下单');
        } else {
            let timer = setInterval(() => {
                time--;
                // console.log(time);
                if (time > 0) {
                    this.setState({
                        countDown: time,
                    });
                } else {
                    this.setState({
                        countDown: 0,
                    });
                    Toast.info('支付过期，请重新下单');
                    clearInterval(timer);
                }
            }, 1000);
        }
    };
    getOrderDetail = () => {
        let params = {
            token: this.props.userInfo.token,
            "data": {
                "id":this.props.history.location.state.id
            }
        };
        getOrderInfo(params)
            .then((res) => {
                console.log(res)
                if (res.data.code === '0000') {
                    let timestamp = (new Date()).getTime();//获取当前时间戳
                    let data = res.data.data;
                    let createTime = data.orderTime;
                    this.setState({
                        passengerName:data.passengerName,
                        phone:data.phone,
                        seatNum:data.seatNum,
                        shiftNum:data.shiftNum,
                        startTime:data.startTime,
                        startAddress:data.startAddress,
                        endAddress:data.endAddress,
                        orderNum:data.orderNum,
                        orderTime:data.orderTime,
                        seatPrice:data.seatPrice,
                        pickUpPrice:data.pickUpPrice,
                        deliveryPrice:data.deliveryPrice,
                        totalPrice:data.totalPrice,
                        payChannel:'',
                        orderId:data.id,
                        startPosition:data.startPosition,
                        endPosition:data.endLocation,
                        status:data.status,
                    })
                    if (data.status === 4) {
                        let timeArea = moment(createTime).add(540, 'seconds').format('x') - timestamp;
                        this.setDownTime(parseInt(timeArea / 1000));
                    }
                }
                else if (res.data.code === '1401') {
                    document.location = `js://toLogin?token=${this.props.userInfo.token}`;
                }
                else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
            console.log(error);
        });
    };
    goPage = (e,k) => {
        //改签
        if(k === 'SelectShift'){
            e.stopPropagation();
            this.props.history.push('/SelectShift',
            {
                startCity:this.props.location.state.data.startCity,
                endCity:this.props.location.state.data.endCity,
                startPosition:this.state.startPosition,
                endPosition:this.state.endPosition,
                id:this.state.orderId,
                startAddress:this.state.startAddress,
                endAddress:this.state.endAddress,
                lineIds:this.props.location.state.lineIds,
            })
        }
        //退款
        if(k === 'refundTicket'){
            e.stopPropagation();
            this.props.history.push('/refundTicket',{id:this.state.orderId})
        }
        //退款详情
        if(k === 'RefundApply'){
            e.stopPropagation();
            this.props.history.push('/RefundApply',{id:this.state.orderId})
        }
        //支付页面
        if(k === 'payDetail'){
            e.stopPropagation();
            this.props.history.push('/payDetail',{
                orderNum:this.state.orderId,
                seatNum:this.state.seatNum,
                totalPrice:this.state.totalPrice,
                type:0,//0是正常支付，1是改签，2是发票
            })
        }
    }
    status(res){
        if(res === 6){//状态 4:待付款 6:未出行 8:行程中 10:取消 11:已完成 9:已改签 13:已退票
            return  <div className="header">
                        <div className="routeStatus">行程未开始！</div>
                        <div className="btn">
                            <div onClick={(e)=>this.goPage(e,'SelectShift')}>改签</div>
                            <div onClick={(e)=>this.goPage(e,'refundTicket')}>退款</div>
                        </div>
                    </div>
        }
        else if(res === 12){
            return  <div className="header">
                        <div className="routeStatus">此行程已申请退款！</div>
                            <div className="refundSteps" onClick={(e)=>this.goPage(e,'RefundApply')}>退款进度</div>
                    </div>
        }
        else if(res === 11){
            return  <div className="header">
                        <div className="routeStatus">订单已完成！</div>
                        <div className="btn">
                            <i className="icon iconfont iconzhifugouxuan"></i>
                        </div>
                    </div>
        }
        else if(res === 4){
            return  <div className="header">
                        <div className="routeStatus">订单未支付！剩余支付时间  <span>{this.state.countDown}s</span></div>
                        {this.state.countDown > 0 ?<div className="pay" onClick={(e)=>this.goPage(e,'payDetail')}>立即支付</div> : <div className="timeOut">订单支付时间已超时，请重新下单</div> }
                    </div>
        }
    };
    render(){
        return(
            <div className="replaceOrder">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >记录详情</NavBar>
                <div className="content">
                    {this.status(this.props.history.location.state.status)}
                    <div className="info">
                        <div className="title">行程信息</div>
                        <div className="body">
                            <div>
                                <span>乘  &nbsp;车 &nbsp;人</span>
                                <span>{this.state.passengerName}</span>
                            </div>
                            {
                                this.state.status == 11 ? null :<div>
                                    <span>联系电话</span>
                                    <a href={`tel: ${this.state.phone} `}> <span className="tel">{this.state.phone}</span></a>
                                </div>
                            }
                            <div>
                                <span>出行位置</span>
                                <span>{this.state.seatNum}</span>
                            </div>
                            <div>
                                <span>班&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;次</span>
                                <span>{this.state.shiftNum}</span>
                            </div>
                            <div>
                                <span>发车时间</span>
                                <span>{this.state.startTime}</span>
                            </div>
                            <div>
                                <span>出发地址</span>
                                <span>{this.state.startAddress}</span>
                            </div>
                            <div>
                                <span>到达地址</span>
                                <span>{this.state.endAddress}</span>
                            </div>
                        </div>
                    </div>
                    <div className="info">
                        <div className="title">支付信息</div>
                        <div className="body">
                            <div>
                                <span>订单编号</span>
                                <span>{this.state.orderNum}</span>
                            </div>
                            <div>
                                <span>下单时间</span>
                                <span>{this.state.orderTime}</span>
                            </div>
                            <div>
                                <span>出行位置价格</span>
                                <span>¥{this.state.seatPrice}</span>
                            </div>
                            <div>
                                <span>出发溢价</span>
                                <span>¥{this.state.pickUpPrice}</span>
                            </div>
                            <div>
                                <span>到达溢价</span>
                                <span>¥{this.state.deliveryPrice}</span>
                            </div>
                            <div>
                                <span>总&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;计</span>
                                <span>¥{this.state.totalPrice}</span>
                            </div>
                            <div>
                                <span>支付方式</span>
                                <span>微信支付</span>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Member/ReplaceOrderInfo/index.js